import React, { useState } from 'react';
import Typography from '../../components/Typography/Typography';
import styles from './style.module.css'
// import { CartContent } from '../../components/CartContent';
import { shoe } from '../../assets/images';
import FlatButtons from '../../components/FlatButton/FlatButton';
import { InputField } from '../../components/InputField';
import { CartItem } from '../../components/CartItem';

const BuyerCheckOutPage: React.FC = () => {

    // const [discountCode, setDiscountCode] = useState("")

    const [streetName, setStreetName] = useState("Thomsone Akpabio")
    const [state, setState] = useState("Uyo")
    const [addInfo, setAddInfo] = useState("")
    const [postalCode, setPostalCode] = useState("1234567")
    const [fullAddress, setFullAddress] = useState("Shelter Afrique, Thomson streetUyo, Akwa Ibom")
    const [edit, setEdit] = useState(true)
    const [tranzakt, setTranzakt] = useState(false)

    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setDiscountCode(e.target.value)
    // }

    const handleChangeStreetName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setStreetName(e.target.value)
    }

    const handleChangeState = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setState(e.target.value)
    }

    const handleChangeAddInfo = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setAddInfo(e.target.value)
    }

    const handleChangePostalCode = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPostalCode(e.target.value)
    }

    const handleChangeFullAddress = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFullAddress(e.target.value)
    }


    const cartItem = [
        {
            id: 1,
            name: "Wireless Bluetooth Headphones",
            category: "Electronics",
            stockNumber: 7,
            colour: "Black",
            price: 89.99,
            image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop&crop=center",
            quantity: 1,
        },
        {
            id: 2,
            name: "Smart Watch",
            category: "Electronics",
            stockNumber: 8,
            colour: "Silver",
            price: 120.0,
            image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=200&h=200&fit=crop&crop=center",
            quantity: 2,
        },
        {
            id: 3,
            name: "Ankle Hight Boots",
            category: "Shoe",
            stockNumber: 7,
            colour: "Black",
            price: 999.29,
            image: `${shoe}`,
            quantity: 1,
        },
        {
            id: 4,
            name: "Running Shoes",
            category: "Footwear",
            stockNumber: 4,
            colour: "Blue",
            price: 75.50,
            image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
            quantity: 1,
        }
    ]

    return (
        <div className={styles.container}>

            <div className={styles.cartContainer}>

                <div className={styles.cart}>

                    <Typography className={styles.cartText}>
                        Address
                    </Typography>

                    <div
                        onClick={() => { setEdit(!edit) }}
                        className={styles.change}
                    >
                        <Typography className={styles.cartText}>
                            Change?
                        </Typography>
                    </div>

                </div>

                <div className={styles.addressContent}>

                    <InputField
                        title='Street Name'
                        value={streetName}
                        onChange={handleChangeStreetName}
                        disable={edit}
                    />

                    <InputField
                        title='State/City'
                        value={state}
                        onChange={handleChangeState}
                        disable={edit}
                    />

                    <InputField
                        title='Additional Information'
                        value={addInfo}
                        onChange={handleChangeAddInfo}
                        disable={edit}
                    />

                    <InputField
                        title='Postal Code'
                        value={postalCode}
                        onChange={handleChangePostalCode}
                        disable={edit}
                    />

                    <InputField
                        title='Full Address'
                        value={fullAddress}
                        onChange={handleChangeFullAddress}
                        disable={edit}
                    />

                </div>

                {/* <div className={styles.updateContainer}>

                    <FlatButtons
                        onClick={() => {
                            // window.location.href = '/choose-template';
                        }}
                        className={styles.primaryButton}
                    >
                        <Typography
                            variant="buttonText"
                            fontFamily="satoshi"
                            weight="regular"
                            size="base"
                            className={styles.primaryButtonText}
                        >
                            Update Cart
                        </Typography>
                    </FlatButtons>

                </div> */}

            </div>

            <div className={styles.summaryContainer}>

                <div className={styles.summary}>

                    <Typography className={styles.summaryText}>
                        Checkout
                    </Typography>

                </div>

                <div className={styles.summaryContent}>

                    <div className={styles.cartItemContainer}>
                        
                        {
                            cartItem.map((item) => (
                                <CartItem
                                    key={item.id}
                                    id={item.id}
                                    name={item.name}
                                    category={item.category}
                                    stockNumber={item.stockNumber}
                                    colour={item.colour}
                                    price={item.price}
                                    image={item.image}
                                    initialQuantity={item.quantity}
                                />
                            ))}

                    </div>

                    <hr className={styles.horizontal}/>

                    <div className={styles.pay}>

                        <div className={styles.detailedSummary}>

                            <div className={styles.detailedSummaryItem}>

                                <Typography
                                    variant='heading6'
                                    className={styles.sub}
                                >
                                    Subtotal
                                </Typography>

                                <Typography className={styles.subAmount}>
                                    $8598549
                                </Typography>

                            </div>

                            {/* <div className={styles.detailedSummaryItem}>

                            <Typography
                                variant='heading6'
                                className={styles.sub}
                            >
                                Discount
                            </Typography>

                            <Typography className={styles.discountAmount}>
                                $3098547
                            </Typography>

                        </div> */}

                            <div className={styles.detailedSummaryItem}>

                                <Typography
                                    variant='heading6'
                                    className={styles.sub}
                                >
                                    Total
                                </Typography>

                                <Typography className={styles.subAmount}>
                                    $748739
                                </Typography>

                            </div>

                        </div>

                        <div
                            onClick={() => { setTranzakt(!tranzakt) }}
                            className={styles.payTranzaktContainer}>

                            <div className={styles.payTranzakt}>

                                <div className={`${tranzakt ? styles.payTagBorderActive : styles.payTagBorder}`}>

                                    <div className={`${tranzakt ? styles.payTagActive : styles.payTag}`}>

                                    </div>

                                </div>
                                <Typography
                                    variant='heading5'
                                >
                                    Pay with Tranzakt
                                </Typography>

                            </div>

                            <div>

                                <Typography>
                                    Make your payment directly with the Tranzakt app, you will be immediately redirected to the payment page
                                </Typography>

                            </div>

                        </div>

                    </div>

                    <div className={styles.proceedBtnContainer}>

                        <FlatButtons
                            onClick={() => {
                                // window.location.href = '/choose-template';
                            }}
                            className={styles.applyButton}
                        >
                            <Typography
                                variant="buttonText"
                                fontFamily="satoshi"
                                weight="regular"
                                size="base"
                                className={styles.applyButtonText}
                            >
                                Checkout
                            </Typography>
                        </FlatButtons>

                    </div>


                </div>

            </div>

        </div>
    );
};

export default BuyerCheckOutPage;
